import { NavLink, useLocation } from "react-router-dom";
import useDataContext from "../../providers/DataProvider/useDataContext";
import "./NavbarLink.css"

interface Props {
    navbarLink: string
    navbarName: string
    isHomePage?: boolean
    isHeader?: boolean
    isScrolled?: boolean
    isExternal?: boolean
}

const NavbarLink: React.FC<Props> = ({ navbarLink, navbarName, isHomePage, isHeader, isScrolled, isExternal }) => {
    const { data } = useDataContext();
    const location = useLocation();

    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const isActive = !isExternal && ((isHomePage && navbarLink === data.components.header.navbar.home.link) || navbarLink === location.pathname);

    return (
        <div className={`flex justify-center lg:border-b-0 lg:py-0 lg:inline-block
                        ${ isHeader ? `border-b-2 rounded-b-2xl w-full py-4
                                       ${ isActive ? "border-b-fifth-solid"
                                                   : `${ isScrolled ? "border-b-first-solid": "border-b-fifth-solid"}`}
                                      `
                                    : ""}`}>
            {
                isExternal
                    ? <a href={navbarLink}
                         target="_blank"
                         rel="noopener noreferrer"
                         className="relative nav__link">
                        { navbarName }
                      </a>
                    : <NavLink to={navbarLink}
                               className={`relative ${isHomePage || isActive ? "nav__link-active" : "nav__link"}`}>
                        { navbarName }
                      </NavLink>
            }
        </div>
    )
}

export default NavbarLink;
